export default {
	ninzhidexinlande: 'あなたの信頼できる旅行パートナー',
	zainalizhaodaonixiangyao: 'どこで安いフライトを見つけますか。',
	zhaodaoyitiaoshihenideluxian: 'あなたに合ったルートを見つける',
	zuijindedijiajipiao: '最近の格安航空券',
	qingshuruhuoxuanzenidechengshi: '目的地を入力または選択してください',
	wodeyuding: '予約リスト',
	kehuzhiyuan: 'カスタマーサポート',
	suoyouhangban: 'すべてのフライト',
	denglu: 'ログイン',
	yingwen: '英語',
	gangbi: '香港ドル',
	baokuoshuifei: '税金込み',
	baokuotuoyunxingli: '受託手荷物込み',
	zhongzhuan: '乗り継ぎ',
	shijian: '時間',
	yuyan: '言語',
	bizhong: '通貨',
	jipiao: '航空券',
	xuesheng: '学生',
	guyong: '雇用',
	haiyuan: '船員',
	lvxingtuan: 'ツアー団体',
	zuche: 'レンタカー',
	laihui: '往復',
	dancheng: '片道',
	duogemudidi: '複数の目的地',
	you: '出発',
	dao: '到着',
	nianling: '年齢',
	sui: '歳',
	chufashijian: '出発時刻',
	fanchengshijian: '帰りの時刻',
	lvke: '旅客',
	cangdeng: 'クラス',
	jingjicang: 'エコノミークラス',
	toudengcang: 'ファーストクラス',
	shangwucang: 'ビジネスクラス',
	gaojijingjicang: 'プレミアムエコノミークラス',
	souxun: '検索',
	remenyouhui: 'スーパーセール',
	remenjingdian: '人気のスポット',
	chengren: '大人',
	xiaotong: '子供',
	yinger: '幼児',
	souxunhangban: 'フライトを検索',
	liaojiegengduo: '詳細',
	guanyu: 'について',
	guanyuwomen: '私たちについて',
	lianluowomen: 'お問い合わせ',
	fukuan: '支払い',
	tiaokuanyuxize: '利用規約と条件',
	yinsizhengce: 'プライバシーポリシー',
	fuwu: 'サービス',
	hangban: 'フライト',
	jiudian: 'ホテル',
	xueshengjipiao: '学生航空券',
	guyongjipiao: '航空券を雇う',
	haiyuanjipiao: '船員航空券',
	changjianwenti: 'よくある質問',
	dingyueyoujian: 'メールマガジン',
	nideyoujian: 'お客様のメールアドレス',
	qingshuru: '入力してください',
	womenjieshou: '確定',
	paixushaixuan: 'ソートとフィルター',
	remenhangbanyouhui: '人気のあるフライトの特典',
	chengshi: '都市',
	yaozuodeshiqing: '人気がある',
	huodong: 'アクティビティ',
	ranggoupiaogengrongyi: "Taro-Trip「チケットを購入しやすくする」という理念を堅持し、ユーザーに質の高いオンラインチケット販売サービスを提供し、顧客の外出に便利を提供し、観光業と経済発展に貢献する。",
	banquansuoyou: '著作権所有',
	xiangtongchengshitishi: '出発都市と目的地都市は同じではありません',
};
